import React from 'react';
import { translations } from '../Text/translations';
import maxActivationImage from '../../assets/max/Max-Activation.png';

const MaxError = ({ currentLang, nickname, mobilenowid, emailnowid }) => {
  return (
    <>
      <div className="name">
        <h2 className="name">{translations[currentLang].maxSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].maxSubjectGreeting2}</h2>
      </div>

      <div className="message">
        <p>{translations[currentLang].maxErrorP}<br /><br />{translations[currentLang].maxErrorP2}</p>
      </div>

      <div className="preview-img">
        <img src={maxActivationImage} alt="" />
      </div>
    </>
  );
};

export default MaxError;